<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label">
          {{ $t('level.mainProgram') }} <span class="text-danger">*</span>
        </label>
        <ts-search-select
          :disabled="editing"
          v-model.number="model.acp_id"
          @change="getSubProgram(model.acp_id)"
          :options="mainProgramOptions"
          @input="model.acps_id = ''"
        ></ts-search-select>
        <div style="color:#cc4946;margin:4px 0 0">
          {{ errors.first('acp_id') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('level.subProgram') }} <span class="text-danger">*</span>
          <i
            v-if="sub_programs.length == 0 && model.acp_id !== ''"
            class="fas fa-spinner fa-pulse label-loading"
          ></i>
        </label>
        <select
          :disabled="editing || sub_programs.length == 0"
          v-model.number="model.acps_id"
          class="form-control"
          :class="{ 'is-invalid': errors.has('acps_id') }"
        >
          <option value="" disabled selected style="display: none;">
            {{ $t('Select') }}</option
          >
          <option
            v-for="(sub_program, index) in sub_programs"
            :key="index"
            :value="sub_program.acps_id"
          >
            {{ sub_program.acps_name_foreign }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('acps_id')">
          {{ errors.first('acps_id') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('level.nameKh') }} </label>
        <input
          ref="level_name_native"
          v-model="model.level_name_native"
          type="text"
          class="form-control kh-font"
          :class="{ 'is-invalid': errors.has('level_name_native') }"
          :placeholder="$t('level.enternameKH')"
        />
        <div class="invalid-feedback" v-if="errors.has('level_name_native')">
          {{ errors.first('level_name_native') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label"
          >{{ $t('level.nameEn') }} <span class="text-danger">*</span>
        </label>
        <input
          v-model="model.level_name_foreign"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('level_name_foreign') }"
          :placeholder="$t('level.enternameEN')"
        />
        <div class="invalid-feedback" v-if="errors.has('level_name_foreign')">
          {{ errors.first('level_name_foreign') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('level.abbreviation') }} </label>
        <input
          v-model="model.level_abbr"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('level_abbr') }"
          placeholder="Enter abbreviation"
        />
        <div class="invalid-feedback" v-if="errors.has('level_abbr')">
          {{ errors.first('level_abbr') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          {{ $t('update') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
          v-else
        >
          {{ $t('save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'level-create-form',
  props: ['edit', 'leave'],
  data() {
    return {
      model: {
        acp_id: '',
        acps_id: '',
        level_name_native: '',
        level_name_foreign: '',
        level_abbr: ''
      },
      errors: new Errors(),
      saving: false,
      editing: false
    }
  },
  created() {
    this.setEdit()
  },
  computed: {
    ...mapState('level', ['sub_programs']),
    mainProgramOptions() {
      return this.$store.state.level.main_programs.map(el => ({
        value: el.acp_id,
        text: el.acp_name_foreign
      }))
    }
  },
  methods: {
    ...mapActions('level', ['getSubProgram']),

    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'level' })
    },

    async save() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch('level/create', this.model)
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch('level/update', this.model)

        this.$toasted.success(response.message)
        this.$router.push({ name: 'level' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit() {
      if (this.edit === null || this.edit === undefined) return
      this.errors = new Errors()
      this.model = {
        level_id: this.edit.level_id,
        acp_id: this.edit.sub_program.main_program.acp_id,
        acps_id: this.edit.sub_program.acps_id,
        level_name_native: this.edit.level_name_native,
        level_name_foreign: this.edit.level_name_foreign,
        level_abbr: this.edit.level_abbr
      }
      this.editing = true
    },

    clearForm() {
      ;(this.model.acp_id = ''),
        (this.model.acps_id = ''),
        (this.model.level_name_native = ''),
        (this.model.level_name_foreign = ''),
        (this.model.level_abbr = '')
    }
  },
  watch: {
    'model.acp_id': function(value) {
      if (value) {
        this.getSubProgram(value)
      }
    },
    leave: {
      handler() {
        if (this.leave) {
          this.clearForm()
          this.editing = false
        }
      }
    },
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
